export default "__VITE_ASSET__BxC$Okgh__"